import ExternalLayer from '../external-layer/external-layer.model';
import GeoJSONPoint from '../geojson-point/geojson-point.model';

export default class ExternalFeature {
    public id = '';
    public ticketId = null;
    public externalLayer: ExternalLayer = new ExternalLayer();
    public objectId = '';
    public position: GeoJSONPoint<{}> = new GeoJSONPoint();
    public other = {};


    /**
     * @param {any} model - It is possible to pass an object to the constructor.
     * If the proper attributes are filled and exist, the constructor will set up the
     * new instance with the provided values.
     */
    constructor(model: any = null) {
        if (model) {
            this.fill(model);
        }
    }

    /**
     * Fills the instance attributes from the given object if the necessary properties
     * are set up and available.
     */
    private fill(model: any) {
        if (model.id) {
            this.id = model.id;
        }
        if (model.externalLayer) {
            this.externalLayer = new ExternalLayer(model.externalLayer);
        }
        if (model.objectId) {
            this.objectId = String(model.objectId);
        }
        if (model.position) {
            this.position = new GeoJSONPoint(model.position);
        }
        if (model.other) {
            this.other = model.other;
        }
    }
}
